import React, { FC } from 'react'
import { Icon } from '@wmgtech/legato'

import { gpsStatuses } from 'modulesCommon/ProductTable/constants'
import { capitalizeFirstLetter } from 'shared/utils/capitalizeFirstLetter'

import { ConditionRender } from 'components'
import { TableRowActions, TableRowActionsSlider } from '..'
import { formatDate } from 'shared/utils/formatDate'

import { IProductTableItemProps } from './ProductTableItem.props'

const ProductTableItem: FC<IProductTableItemProps> = ({
  idx,
  product,
  handleRowClose,
  handleRowEdit,
  isEditable = true
}) => (
  <div className="product-table__item">
    <div className="product-table__col product-table__col--type">{capitalizeFirstLetter(product.configuration)}</div>
    <div className="product-table__col product-table__col--name">{product.name}</div>
    <div className="product-table__col product-table__col--status">
      {gpsStatuses[product.gps_status] || 'No Track Status'}
    </div>
    <div className="product-table__col product-table__col--date">
      {formatDate({ date: new Date(product.publish_date), withTime: false })}
    </div>
    <ConditionRender
      condition={isEditable}
      component={
        <div className="product-table__col product-table__col--actions">
          <TableRowActions>
            <div onClick={() => handleRowEdit(idx)} className="table-row-actions__item">
              Edit Product <Icon name="pencil" />
            </div>
            <TableRowActionsSlider
              className="table-row-actions__item"
              fieldName={`products.${idx}.radio_updates`}
              label="Automated Radio Stories"
            />
            <TableRowActionsSlider
              className="table-row-actions__item"
              fieldName={`products.${idx}.dsp_updates`}
              label="Automated DSP Stories"
            />
            <div onClick={() => handleRowClose(idx, null)} className="table-row-actions__item">
              Delete Product <Icon name="trash-can" />
            </div>
          </TableRowActions>
        </div>
      }
    />
  </div>
)

export default ProductTableItem
